import { render, staticRenderFns } from "./Atendimentos.vue?vue&type=template&id=fe2a483c&scoped=true&"
import script from "./Atendimentos.vue?vue&type=script&lang=js&"
export * from "./Atendimentos.vue?vue&type=script&lang=js&"
import style0 from "./Atendimentos.vue?vue&type=style&index=0&id=fe2a483c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2a483c",
  null
  
)

export default component.exports